<template>
    <div v-if="contrato">
        <form class="form-horizontal" >
            <div class="form-group">
                <div class="col-sm-12">
                    <label class="control-label">NOME DO CLIENTE</label>
                    <input disabled type="text" v-model="contrato.cliente.nome" class="form-control" >
                </div>
            </div>
            <list-atendimentos @open="open" :id="contrato._id"></list-atendimentos>

            <div class="modal fade atendimento-model" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content" v-if="atendimento">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title" id="gridSystemModalLabel">[ {{ atendimento.protocolo.final }} ] - {{ atendimento.contrato.cliente.nome }}</h4>
                        </div>
                        <div class="modal-body" >

                            <div class="row">
                                <form style="padding: 10px">

                                    <div class="col-sm-2">
                                        <div class="row" style="padding: 2px">
                                            <label for="PROTOCOLO" class="control-label">PROTOCOLO</label>
                                            <input type="text" id="PROTOCOLO" disabled :value="atendimento.protocolo.final" class="form-control">
                                        </div>
                                    </div>

                                    <div class="col-sm-10" >
                                        <div class="row" style="padding: 2px">
                                            <label for="MOTIVO" class="control-label">MOTIVO</label>
                                            <input type="text" id="MOTIVO" disabled :value="atendimento.motivo.nome" class="form-control">
                                        </div>
                                    </div>

                                    <div class="col-sm-12" >
                                        <div class="row" style="padding: 2px">
                                            <label for="message-text" class="control-label">OBS</label>
                                            <textarea rows="4" disabled readonly :value="atendimento.obs" class="form-control" id="message-text"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-sm-12" >
                                        <br/>
                                        <div class="row" style="padding: 2px">
                                            <table id="mytable" class="table table-bordred table-striped">

                                                <thead>
                                                    <tr>
                                                        <th>AÇÔES TOMADAS PELO MONITOR</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-bind:key="r.nome" v-for="r in atendimento.acoes">
                                                        <td>{{ r.nome }}</td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>

                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import ListAtendimentos from "../../../components/contratos/ListAtendimentos.vue";
import contratoMixin from "../../mixins/contrato";
import { Atendimento } from "../../../class/index";

export default {
    components: {
        ListAtendimentos
    },
    mixins: [contratoMixin],
    data() {
        return {
            atendimento: null
        };
    },
    mounted() {
        // eslint-disable-next-line no-undef
        $(".atendimento-model").on("hidden.bs.modal", () => {
            this.atendimento = null;
        });
    },
    methods: {
        async open(id) {
            this.atendimento = await Atendimento.byID(id);
            // eslint-disable-next-line no-undef
            $(".atendimento-model").modal("show");
        }
    }
};
</script>
